class Notification {
  constructor() {
    this.initialized = false;
  }
  register(methods) {
    if (this.initialized) {
      console.error(
        `Notifications Container initializer has been called more than once.
        You must ensure this component will not re-render otherwise unexpected
        behavior may happen.
        `
      );
      return;
    }
    this.initialized = true;
    const { create, destroy, dismiss } = methods;
    this.create = create;
    this.destroy = destroy;
    this.dismiss = dismiss;
  }
}
var Notification$1 = new Notification();

export { Notification$1 as default };
//# sourceMappingURL=bundle.esm.js.map
